

function drawLine(ctx, startX, startY, endX, endY,color){
    ctx.save();
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.moveTo(startX,startY);
    ctx.lineTo(endX,endY);
    ctx.stroke();
    ctx.restore();
}

function drawBar(ctx, upperLeftCornerX, upperLeftCornerY, width, height,color){
    ctx.save();
    ctx.fillStyle=color;
    ctx.fillRect(upperLeftCornerX,upperLeftCornerY,width,height);
    ctx.restore();
}

class BarChart {
  constructor(options) {
    this.options = options;
    this.canvas = options.canvas;
    this.ctx = this.canvas.getContext("2d");
    this.colors = options.colors;
    this.titleOptions = options.titleOptions;

    this.maxValue = 0 ;
    for (let x of this.options.data) {
      if (this.maxValue < x[1])
          this.maxValue = x[1]
    }

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  drawLabel() {

    this.ctx.save();
    this.ctx.textBaseline = "bottom";
    this.ctx.textAlign = this.titleOptions.align;
    this.ctx.fillStyle = this.titleOptions.fill;
    let xPos = 50 ;

    let rclist = this.options.data ;
    let xinc = (this.canvas.width - xPos) / rclist.length ;

    this.ctx.font = `thin 12px ${this.titleOptions.font.family}`;

    for (let x of rclist)  {
      this.ctx.fillStyle = "black" ;
      let unit = x[0] ;
      if (unit.length <= 2)
         this.ctx.fillText(unit, xPos, this.canvas.height - 30);
      else {
        let y = this.canvas.height - 16 - unit.length * 16 ;
        for (let i = 0 ; i < unit.length ; i++) {
          let c = unit[i] ;
          this.ctx.fillText(c, xPos, y);
          y += 16 ;
        }
      }
      xPos += xinc ;
    } 
    this.ctx.restore();
  }
  
  drawGridLines() {
    var canvasActualHeight = this.canvas.height - this.options.padding * 2;
    // var canvasActualWidth = this.canvas.width - this.options.padding * 2;
    var gridValue = 0;
    let i = 0 ;
    while (gridValue <= this.maxValue) {
      var gridY =
        canvasActualHeight * (1 - gridValue / this.maxValue) +
        this.options.padding;
      drawLine(
        this.ctx,
        0,
        gridY,
        this.canvas.width,
        gridY,
        this.options.gridColor
      );
      drawLine(
        this.ctx,
        30,
        this.options.padding/2,
        30,
        gridY + this.options.padding/2,
        this.options.gridColor
      );
      // Writing grid markers 
      this.ctx.save();
      this.ctx.fillStyle = "black" ;
      this.ctx.textBaseline = "bottom";
      this.ctx.font = "thin 8px Courier";

      let unit = Math.round(gridValue) ;
      let x = gridValue ;
      if (x > 1000000) { 
          x = Math.round(x / 1000000) ;
          unit = x + "M"  ;
      } else if (x > 1000) {
          x = Math.round (x / 1000) ;
          unit = x + "K"  ;
      }
      if (i % 2 == 0)
        this.ctx.fillText(unit, 0, gridY - 2);
      i++ ;
      this.ctx.restore();
      gridValue +=  this.maxValue / this.options.gridScale ;
    }
  }


  drawBars() {
    var canvasActualHeight = this.canvas.height - this.options.padding * 2;
    var canvasActualWidth = this.canvas.width - this.options.padding * 2;
    var barIndex = 0;
    var numberOfBars = this.options.data.length;
    var barSize = canvasActualWidth / numberOfBars;
    
    var values = this.options.data ;
    for (let val of values) {
      var barHeight = Math.round((canvasActualHeight * val[1]) / this.maxValue);
      
      drawBar(
        this.ctx,
        this.options.padding + barIndex * barSize,
        this.canvas.height - barHeight - this.options.padding,
        barSize,
        barHeight,
        this.colors[barIndex % this.colors.length]
      );
      barIndex++;
    }
  }
  
  draw_pie() {
    let radius = Math.round(this.canvas.height/2.5);
    var centerY  = (this.canvas.height / 2 ) 
    var centerX  = (this.canvas.width  / 2 - 30) 
    let smallY =  centerY - 30 ;

    let data = this.options.data ;
    let totval = 0 ;

    for (let val of data) 
      totval += parseFloat(val[1]) ;

    this.ctx.lineWidth = 2 ;
    this.ctx.strokeStyle = "#000000" ;

    let startrad = 0 ;
    for (let i = 0 ; i < data.length ; i++) {
        let rad = parseFloat(data[i][1]) * Math.PI * 2 / totval  ;
        this.ctx.beginPath();
        this.ctx.moveTo(centerX, centerY) ;
        this.ctx.arc(centerX, centerY, radius, startrad, startrad + rad);
        this.ctx.closePath();
        this.ctx.stroke();
        this.ctx.fillStyle = this.colors[i] ;
        this.ctx.fill();

        let labradius = radius/1.5; //use suitable radius
        let endAngle = (startrad + rad / 2) ;
        var setX = centerX + Math.cos(endAngle) * labradius;
        var setY = centerY + Math.sin(endAngle) * labradius ;
        this.ctx.fillStyle = "#000000";
        this.ctx.font = "12px Arial";
        let percentV = Math.round(parseFloat(data[i][1]) * 10000 / totval) / 100 ;
        if (percentV > 10) {
          percentV = percentV.toString() + '%' ;
          this.ctx.textAlign = "center" ;
          this.ctx.fillText(percentV,setX,setY);
        }
        else if (percentV > 0.1) {
          this.ctx.beginPath();
          this.ctx.arc(centerX + radius + 30, smallY, 8, 0, Math.PI * 2);
          this.ctx.fillStyle = this.colors[i] ;
          this.ctx.fill();
          this.ctx.textAlign = "left" ;
          this.ctx.fillText(percentV.toString() + '%', centerX + radius + 48, smallY + 6);
          smallY += 20 ;
        }
        startrad += rad ;
    }
  }

  draw(gtype) {

    if (gtype == "BAR") {
      this.drawGridLines();
      this.drawBars();
      this.drawLabel();
    }
    else this.draw_pie() ;
  }
}

export default BarChart ;
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
